import axios from 'axios';

export const call = async ({ method = 'GET', url, data, token }) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = token;
  } else delete axios.defaults.headers.common['Authorization'];
  const backendURL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_BACKEND_URL_DEV : process.env.REACT_APP_BACKEND_URL_PROD;
  let __internalCall = axios[method.toLocaleLowerCase()](backendURL + url, data);

  return await __internalCall
    .then((response) => {
      if (response.data.newToken) {
        localStorage.removeItem('accessToken');
        localStorage.setItem('accessToken', response.data.newToken);
        return response.data.data;
      } else {
        return response.data;
      }
    })
    .catch((err) => {
      if (err?.response?.status === 500 || err) {
        if (err.response?.data.error === 'NOT AUTHORIZED' || err.response?.data.error === 'NO USER') {
          //reset the local storage and reload the page to go to login
          localStorage.removeItem('userId');
          localStorage.removeItem('accessToken');
          location.reload();
          return Promise.reject("Sessione scaduta, effettua nuovamente l'accesso");
        }
        return Promise.reject("Errore server, contattare l'assistenza!");
      }
      return Promise.reject(err.response.data.error);
    });
};
